export const DASHBOARD_HELP_REQUEST = 'charitystack:open-dashboard-help';

/** Route custom support links through the dashboard's surface coordinator when mounted. */
export function requestDashboardHelp() {
  return !window.dispatchEvent(new Event(DASHBOARD_HELP_REQUEST, { cancelable: true }));
}
